import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Public progress bar — "Help us reach 10,000 readers" social-proof widget. */
const SubscriberProgress = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/api/stats/subscribers`);
        if (!cancelled) setStats(res.data);
      } catch {
        if (!cancelled) setStats(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!stats) return null;

  const { active_subscribers, goal } = stats;
  const pct = Math.min(100, (active_subscribers / goal) * 100);
  const isEarly = active_subscribers < goal * 0.05;

  return (
    <div className="max-w-2xl mx-auto" data-testid="subscriber-progress">
      <div className="flex items-center justify-between mb-2 text-sm">
        <div className="flex items-center gap-2 text-gray-700">
          <Users size={16} className="text-gray-500" />
          <span className="font-medium">{active_subscribers.toLocaleString()}</span>
          <span className="text-gray-500">readers · goal {goal.toLocaleString()}</span>
        </div>
        <span className="text-gray-500 tabular-nums">{pct.toFixed(2)}%</span>
      </div>
      <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-600 to-emerald-500 transition-all duration-700"
          style={{ width: `${Math.max(pct, 0.5)}%` }}
        />
      </div>
      {isEarly ? (
        <p className="text-xs text-gray-500 mt-2 text-center">
          Be one of the first 100. Subscribers see new posts before anyone else.
        </p>
      ) : null}
    </div>
  );
};

export default SubscriberProgress;
